import { useState } from 'react';
import { useT } from '@/i18n';
import { clearCrashLog, formatCrash, readCrashLog } from '@/lib/crashLog';
import { formatDateTime } from '@/lib/time';

/** The local crash log, for reporting a blank page or a failed action from a deployed build. */
export function CrashLog() {
  const { t } = useT();
  const [entries, setEntries] = useState(readCrashLog);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <span className="label">{t('settings.crashes')}</span>
      {entries.length === 0 ? (
        <span className="muted" style={{ fontSize: 12 }}>{t('settings.crashesNone')}</span>
      ) : (
        <>
          <pre className="crashText" style={{ maxHeight: 220 }}>{entries.map((c) => `${formatDateTime(c.at)} · ${c.kind} · ${c.url}\n${c.message}`).join('\n\n')}</pre>
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" className="btn quiet" onClick={() => void navigator.clipboard?.writeText(entries.map(formatCrash).join('\n\n'))}>{t('settings.crashesCopy')}</button>
            <button type="button" className="btn quiet" onClick={() => { clearCrashLog(); setEntries([]); }}>{t('settings.crashesClear')}</button>
          </div>
        </>
      )}
    </div>
  );
}
